var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressHighlighter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 118,
    viewBox: "0 0 29 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#progress-highlighter-filter)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12L16.9335 103.501C16.97 104.87 15.8698 106 14.5 106C13.1302 106 12.03 104.87 12.0665 103.501L14.5 12Z",
    fill: "url(#paint0_linear_388_1111)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12L16.9335 103.501C16.97 104.87 15.8698 106 14.5 106C13.1302 106 12.03 104.87 12.0665 103.501L14.5 12Z",
    fill: "url(#paint1_linear_388_1111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "progress-highlighter-filter",
    x: 0.815552,
    y: 0.75,
    width: 27.3689,
    height: 116.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.625,
    result: "effect1_foregroundBlur_388_1111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_1111",
    x1: 14.5,
    y1: 12,
    x2: 14.5,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ABE1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9ABE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_388_1111",
    x1: 14.5,
    y1: 12,
    x2: 14.5,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ABE1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9ABE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressHighlighter);
export default __webpack_public_path__ + "static/media/progress-highlighter.186dec34a0a240abcf9249ee84c113fe.svg";
export { ForwardRef as ReactComponent };